import React, { useState, useEffect } from 'react';
import CommonBadges from '../../Shared/Badges';
import { indianTimeZone, USATimeZone } from '../../../utils/helper';
import { BorderColor } from '@mui/icons-material';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';

const Countdown = ({ lastActive }) => {
  const calculateRemainingTime = () => {
    const now = new Date();
    // const lastActiveDate = indianTimeZone(lastActive);
    const lastActiveDate = new Date(
      lastActive.includes('Z') ? lastActive : lastActive + 'Z'
    );
    const diffInMs = now - lastActiveDate;
    const diffInSec = Math.floor(diffInMs / 1000);
    const remainingTime = 24 * 60 * 60 - diffInSec;
    return remainingTime > 0 ? remainingTime : 0;
  };

  const [count, setCount] = useState(calculateRemainingTime());

  useEffect(() => {
    const timer = setInterval(() => {
      setCount(calculateRemainingTime());
    }, 1000);

    return () => clearInterval(timer);
  }, [lastActive]);

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs}:${mins}:${secs}`;
  };

  return (
    <>
      {/* <CommonBadges
                value={count ? formatTime(count) : 'Resolved'}
                color={count ? 'Success' : 'error'}
                variant="outlined"
                className="css-zezwi5-MuiListItemSecondaryAction-root "
                style={{
                    border:'1px solid #008F3C',
                    color: '#008F3C',
                    fontSize: '10px',
                    fontWeight:400,
                    height:'19px',
                    lineHeight:'1',
                    background:'#EAFFF3',
                }}
            /> */}

      <CommonBadges
        icon={count ? <AccessAlarmIcon style={{ fontSize: '14px' }} /> : null}
        value={count ? formatTime(count) : 'Expired'}
        color={count ? 'primary' : 'error'}
        variant="outlined"
        className="css-qyn9x1-MuiChip-root"
        style={{
          border: '1px solid #EB1C1C',
          color: '#EB1C1C',
          fontSize: '10px',
          fontWeight: 400,
          height: { sm: '20.5px', md: '20.5px', lg: '20.5px' },
          lineHeight: '1',
        }}
      />
    </>
  );
};

export default Countdown;
